import React from 'react';
import { useTranslation } from 'react-i18next';
import fileSearch from 'src/assets/img/file-search.svg';
import preferencesPopup from 'src/assets/img/preferences-popup.svg';
import receipt from 'src/assets/img/receipt.svg';
import sharingKnowledge from 'src/assets/img/sharing-knowledge.svg';

const ServiceTemplates = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  return (
    <div className="stack padding-x--1">
      <h2>{tHelpAndSupport('commonQuestions.ServiceTemplates.HowTo')}</h2>
      <div className="stack-large">
        <PageSection
          imgSrc={fileSearch}
          imgAlt="Illustrasjon av dokumenter med et forstørrelsesglass over"
          title={tHelpAndSupport('commonQuestions.ServiceTemplates.Section1.Title')}
          description={tHelpAndSupport('commonQuestions.ServiceTemplates.Section1.Description')}
        />

        <PageSection
          imgSrc={preferencesPopup}
          imgAlt="Illustrasjon av et popup-vindu med innstillinger og preferanser"
          title={tHelpAndSupport('commonQuestions.ServiceTemplates.Section2.Title')}
          description={tHelpAndSupport('commonQuestions.ServiceTemplates.Section2.Description')}
        />

        <PageSection
          imgSrc={receipt}
          imgAlt="Illustrasjon av en oppsummering"
          title={tHelpAndSupport('commonQuestions.ServiceTemplates.Section3.Title')}
          description={tHelpAndSupport('commonQuestions.ServiceTemplates.Section3.Description')}
        />

        <PageSection
          imgSrc={sharingKnowledge}
          imgAlt="Illustrasjon av overrekking av et dokument"
          title={tHelpAndSupport('commonQuestions.ServiceTemplates.Section4.Title')}
          description={tHelpAndSupport('commonQuestions.ServiceTemplates.Section4.Description')}
        />
      </div>
    </div>
  );
};

const PageSection = ({
  imgSrc,
  title,
  description,
  imgAlt,
}: {
  imgSrc: string;
  title: string;
  description: string;
  imgAlt: string;
}) => {
  return (
    <div className="stack-medium display--flex flex-direction--column">
      <img className="width--65 align-self--center" alt={imgAlt} src={imgSrc}></img>
      <div className="stack-small">
        <h3 className="font-weight--bold font-size--x-large">{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
};

export default ServiceTemplates;
